import {Link} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import {useIntl} from 'react-intl';

const Error404 = (): JSX.Element => {
    const intl = useIntl();

    return (
        <div className={'page-not-found'}>
            <div className="img-div">
                <img src={toAbsoluteUrl('/media/auth/error_page.png')} className="mw-100" alt="" />
            </div>
            <h1 className="fw-bolder text-gray-900 mb-4">404</h1>
            <div className="fw-bold fs-2 text-celeste-primary mb-7">
                {intl.formatMessage({id: 'ERROR_PAGE.NOT_FOUND'})}
            </div>
            <div className="fs-6 mb-7">{intl.formatMessage({id: 'ERROR_PAGE.ASSISTANCE'})}</div>
            <div className="mb-0">
                <Link to="/dashboard" className="btn btn-sm btn-primary">
                    {intl.formatMessage({id: 'ERROR_PAGE.RETURN_HOME'})}
                </Link>
            </div>
        </div>
    );
};

export {Error404};
